<template>
  <div>
    <nav class="navbar navbar-custom">
      <div
        class="container px-4 navbar-content d-flex justify-content-between align-items-center"
      >
        <a class="navbar-brand d-inline-block navbar-brand-custom">
          <img
            class="logo-img"
            src="../assets/new_ui/image-1@3x.png"
            alt="Letmein LOGO"
          />
        </a>

        <select
          id="langSelected"
          v-model="locale"
          class="form-select d-inline-block"
          aria-label="Select language"
          :disabled="isDisable"
          @change="reload()"
        >
          <option v-for="(msg, i) in language" :key="`locale${i}`" :value="i">
            {{ msg }}
          </option>
        </select>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "NavbarComponents",
  data() {
    return {
      language: {
        en: "English",
        th: "\u0e44\u0e17\u0e22",
      },
    };
  },
  computed: {
    locale: {
      get: function () {
        console.log("get: ", this.$store.state.locale);
        return this.$store.state.locale;
      },
      set: function (newVal) {
        console.log("set: ", newVal);
        this.$store.dispatch("changeLocale", newVal);
      },
    },

    isDisable() {
      if (this.$route.name === "paymentparking") return true;
      else return false;
    },
  },
  methods: {
    reload() {
      if (this.$route.name != "paymentparking") {
        this.$router.go();
      }
    },
  },
};
</script>

<style>
.navbar-custom {
  background-color: #ffffff;
  min-height: 100px;
  width: 100%;
  padding: 0;
  box-shadow: 0 0 44px 0 rgba(111, 111, 111, 0.25);
}

.navbar-content {
  gap: 1rem;
  min-height: 100px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  flex-wrap: nowrap;
}

.navbar-brand-custom {
  margin-right: 1rem;
  margin-bottom: 0;
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
}

.navbar-custom .logo-img {
  max-width: 15rem;
  width: 100%;
  height: auto;
}

select#langSelected {
  width: clamp(116px, 19vw, 120px) !important;
  min-width: 116px;
  height: clamp(33px, 4vw, 40px);
  background-color: white !important;
  border: 1.5px solid #b3bdc2 !important;
  border-radius: 0 !important;
  color: #233142 !important;
  outline: none !important;
  font-weight: light;
  font-size: clamp(0.9rem, 1.5vw, 1rem);
  line-height: 1.2;
  padding-top: 0.35rem !important;
  padding-bottom: 0.35rem !important;
  padding-left: 2rem !important;
  padding-right: 2.1rem !important;
  background-image:
    url("../assets/new_ui/icon-set-globe-black-medium@3x.png"),
    url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23b3bdc2' viewBox='0 0 16 16'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/></svg>") !important;
  background-repeat: no-repeat, no-repeat !important;
  background-position:
    left 0.3rem center,
    right 0.8rem center !important;
  background-size:
    1.2rem 1.2rem,
    15px 15px !important;
  flex: 0 0 auto;
}

select#langSelected option {
  color: #233142;
  background-color: #ffffff;
  font-weight: 500;
}

select#langSelected {
  scrollbar-width: thin;
  scrollbar-color: #b3bdc2 transparent;
}

select#langSelected::-webkit-scrollbar {
  width: 4px;
}

select#langSelected::-webkit-scrollbar-track {
  background: transparent;
}

select#langSelected::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background-color: #b3bdc2;
}

@media (max-width: 576px) {
  .navbar-custom {
    min-height: auto;
  }

  .navbar-content {
    justify-content: space-between !important;
    align-items: center !important;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
    gap: 0.75rem;
  }

  .navbar-custom .logo-img {
    max-width: 9.75rem;
  }

  select#langSelected {
    width: clamp(96px, 28vw, 112px) !important;
    min-width: 96px;
    height: 33px;
    margin: 0;
    font-size: 0.85rem;
    padding-left: 1.85rem !important;
    padding-right: 1.85rem !important;
    background-position:
      left 0.3rem center,
      right 0.65rem center !important;
    background-size:
      1.2rem 1.2rem,
      15px 15px !important;
    flex-shrink: 0;
  }
}
</style>
